var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1.99v6m0 0h6m-6 0l4.64-4.36a9 9 0 11-2.13 9.36","stroke":"#6B7388","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Clear.defaultProps = {"width":"22","height":"20","fill":"none"};

module.exports = Clear;

Clear.default = Clear;
